export default __webpack_public_path__ + "static/media/testing-matters.88fa35a2.svg";